export function removeKey<V>(map: Record<string, V>, key: string): Record<string, V> {
  const { [key]: val, ...rest } = map;

  return val !== undefined ? rest : map;
}

export function removeKeys<V>(map: Record<string, V>, keys: readonly string[]): Record<string, V> {
  return keys.reduce((acc, key) => removeKey(acc, key), map);
}
